module.exports = __webpack_public_path__ + "img/newchris-70.d06d4132.jpg";